export default __webpack_public_path__ + "static/media/2.24e895fd.jpg";